<template>
    <div
        class="flex w-screen flex-row items-center justify-center gap-2 bg-neutral-100 py-2 font-600 text-sm leading-[24px] text-neutral-950 shadow-md"
        @click="handleClick"
    >
        <IconWhatsappFilled class="size-7 text-white" />
        <span>Need any changes?</span>
        <span class="border-b-2 border-neutral-600">Message us</span>
    </div>
</template>
<script setup lang="ts">
function handleClick() {
    window.open('https://wa.me/14257280395', '_blank')
}
</script>
